import React from "react"
import { Flex, Text } from "@theme-ui/components"
import { OutboundLink } from "./link"
import { Phone } from "react-feather"

const GreenNumber = ({}) => {
  return (
    <Flex
      sx={{
        flexDirection: "column",
        justifyContent: "center",
        flexBasis: "auto",
        width: "auto",
      }}
    >
      <OutboundLink href="tel:800480110" sx={{ textDecoration: "none" }}>
        <Flex
          sx={{
            backgroundColor: "#2ECC40",
            p: 3,
            borderRadius: "0",
            color: "#fff",
            justifyContent: "center",
            transition: "all .3s",
            "&:hover": { backgroundColor: "#007aff" },
          }}
        >
          <Phone />
          <Text sx={{ ml: 2, fontWeight: "700" }}>800 480110</Text>
        </Flex>
      </OutboundLink>
      {/* <Text sx={{ fontSize: 0, textAlign: "center", color: "#2ECC40", mt: 1 }}>
        Numero verde gratuito
      </Text> */}
    </Flex>
  )
}

export default GreenNumber
